import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

export const adjustPosition = (
  position: RelativeAbsolutePosition,
  delta: number,
): RelativeAbsolutePosition => {
  return {
    relative: {
      x: position.relative.x + delta,
      y: position.relative.y,
    },
    absolute: {
      x: position.absolute.x + delta,
      y: position.absolute.y,
    },
  };
};
